module.exports = __webpack_public_path__ + "static/img/4176_phase_function_Paper_PointsHejduk_Prediction.9a56853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4176_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nVuO
// module chunks = 0